import type { DEVICE_CODE_POSSIBLE_LENGTH } from "../constants";

export type DeviceAllowedCodeLength = (typeof DEVICE_CODE_POSSIBLE_LENGTH)[keyof typeof DEVICE_CODE_POSSIBLE_LENGTH];
